import { render, staticRenderFns } from "./DsbOrderDetailItem.vue?vue&type=template&id=b50eaf8a"
import script from "./DsbOrderDetailItem.vue?vue&type=script&lang=ts"
export * from "./DsbOrderDetailItem.vue?vue&type=script&lang=ts"
import style0 from "./DsbOrderDetailItem.vue?vue&type=style&index=0&id=b50eaf8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports